export default "__VITE_ASSET__efpMb2nn__"